var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScheduleActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2779 1V4.36842",
    stroke: "#0085FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.72222 1V4.36842",
    stroke: "#0085FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.89474H18",
    stroke: "#0085FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1111 2.68421H2.88889C1.84528 2.68421 1 3.43789 1 4.36842V15.3158C1 16.2463 1.84528 17 2.88889 17H16.1111C17.1547 17 18 16.2463 18 15.3158V4.36842C18 3.43789 17.1547 2.68421 16.1111 2.68421Z",
    stroke: "#0085FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.51217 10.035C9.38184 10.035 9.27606 10.1293 9.27701 10.2455C9.27701 10.3617 9.38279 10.456 9.51312 10.456C9.64345 10.456 9.74923 10.3617 9.74923 10.2455C9.74923 10.1293 9.64345 10.035 9.51217 10.035",
    stroke: "#0085FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2345 10.035C14.1041 10.035 13.9984 10.1293 13.9993 10.2455C13.9993 10.3617 14.1051 10.456 14.2354 10.456C14.3657 10.456 14.4715 10.3617 14.4715 10.2455C14.4715 10.1293 14.3657 10.035 14.2345 10.035",
    stroke: "#0085FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79001 13.4034C4.65967 13.4034 4.5539 13.4977 4.55484 13.6139C4.55484 13.7301 4.66062 13.8245 4.79095 13.8245C4.92128 13.8245 5.02706 13.7301 5.02706 13.6139C5.02706 13.4977 4.92128 13.4034 4.79001 13.4034",
    stroke: "#0085FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.51217 13.4034C9.38184 13.4034 9.27606 13.4977 9.27701 13.6139C9.27701 13.7301 9.38279 13.8245 9.51312 13.8245C9.64345 13.8245 9.74923 13.7301 9.74923 13.6139C9.74923 13.4977 9.64345 13.4034 9.51217 13.4034",
    stroke: "#0085FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleActive);
export default __webpack_public_path__ + "static/media/schedule-active.e98728325c25121feca983406e56fde6.svg";
export { ForwardRef as ReactComponent };